const mockMachines = [
  {
    id: "V24-6333",
    prefix: "V24",
    number: "6333",
    code: "V24-6333",
    name: "Maquina 6333",
    avgPerHour: 300,
    utilizationRate: 90,
    site: "UP NORTE",
    line: "Linha A",
    riskLevel: "Baixo",
    requiredOperators: 2,
    productivityFactor: 1,
    maintenanceSensitivity: 1,
    riskSensitivity: 0.12,
  },
  {
    id: "V25-6335",
    prefix: "V25",
    number: "6335",
    code: "V25-6335",
    name: "Maquina 6335",
    avgPerHour: 300,
    utilizationRate: 90,
    site: "UP NORTE",
    line: "Linha A",
    riskLevel: "Baixo",
    requiredOperators: 2,
    productivityFactor: 1,
    maintenanceSensitivity: 1,
    riskSensitivity: 0.12,
  },
  {
    id: "V26-6336",
    prefix: "V26",
    number: "6336",
    code: "V26-6336",
    name: "Maquina 6336",
    avgPerHour: 300,
    utilizationRate: 90,
    site: "UP NORTE",
    line: "Linha A",
    riskLevel: "Alto",
    requiredOperators: 2,
    productivityFactor: 1,
    maintenanceSensitivity: 1.05,
    riskSensitivity: 0.2,
  },
  {
    id: "V27-6339",
    prefix: "V27",
    number: "6339",
    code: "V27-6339",
    name: "Maquina 6339",
    avgPerHour: 300,
    utilizationRate: 90,
    site: "UP CENTRO",
    line: "Linha A",
    riskLevel: "Baixo",
    requiredOperators: 2,
    productivityFactor: 1,
    maintenanceSensitivity: 1,
    riskSensitivity: 0.12,
  },
  {
    id: "V28-6449",
    prefix: "V28",
    number: "6449",
    code: "V28-6449",
    name: "Maquina 6449",
    avgPerHour: 250,
    utilizationRate: 90,
    site: "UP CENTRO",
    line: "Linha B",
    riskLevel: "Medio",
    requiredOperators: 2,
    productivityFactor: 1,
    maintenanceSensitivity: 1.03,
    riskSensitivity: 0.16,
  },
  {
    id: "V20-6450",
    prefix: "V20",
    number: "6450",
    code: "V20-6450",
    name: "Maquina 6450",
    avgPerHour: 560,
    utilizationRate: 90,
    site: "UP PORTOS",
    line: "Linha C",
    riskLevel: "Medio",
    requiredOperators: 3,
    productivityFactor: 1,
    maintenanceSensitivity: 1.08,
    riskSensitivity: 0.18,
  },
  {
    id: "V21-6451",
    prefix: "V21",
    number: "6451",
    code: "V21-6451",
    name: "Maquina 6451",
    avgPerHour: 560,
    utilizationRate: 90,
    site: "UP PORTOS",
    line: "Linha C",
    riskLevel: "Medio",
    requiredOperators: 3,
    productivityFactor: 1,
    maintenanceSensitivity: 1.08,
    riskSensitivity: 0.18,
  },
  {
    id: "V22-6452",
    prefix: "V22",
    number: "6452",
    code: "V22-6452",
    name: "Maquina 6452",
    avgPerHour: 560,
    utilizationRate: 90,
    site: "UP SERRAS",
    line: "Linha C",
    riskLevel: "Medio",
    requiredOperators: 3,
    productivityFactor: 1,
    maintenanceSensitivity: 1.08,
    riskSensitivity: 0.18,
  },
  {
    id: "V23-6453",
    prefix: "V23",
    number: "6453",
    code: "V23-6453",
    name: "Maquina 6453",
    avgPerHour: 560,
    utilizationRate: 90,
    site: "UP SERRAS",
    line: "Linha C",
    riskLevel: "Baixo",
    requiredOperators: 3,
    productivityFactor: 1,
    maintenanceSensitivity: 1.05,
    riskSensitivity: 0.14,
  },
];

export default mockMachines;
